import React, { useState, useEffect } from "react";
import Sidebar from './composant_reutilisable/sidebar';
import Navbar from "./composant_reutilisable/navbar";
import { Link } from "react-router-dom";
import { Modal, Button, Form, ProgressBar } from "react-bootstrap";
import {
    FaEdit, FaPlus, FaTrash, FaEllipsisV,
    FaSortAmountUp, FaSortAmountDown,
    FaArrowLeft,
    FaArrowRight,
    FaBoxOpen,
    FaLeaf,
    FaFileImport,
    FaChevronUp,
    FaChevronDown,
    FaQuestionCircle,
    FaBed,
} from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import { FaRoadBarrier } from "react-icons/fa6";

const Chambre = () => {
    // useAuth();
    const navigate = useNavigate();

    const [showInfo, setShowInfo] = useState(false);

    const [isLoading, setIsLoading] = useState(false);
    const [sortConfig, setSortConfig] = useState({
        key: "id",
        direction: "descending",
    });
    const user_id = localStorage.getItem('userId');
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [alertModal, setAlertModal] = useState({ message: '', type: '' });

    const [chambres, setChambres] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showModifierModal, setShowModifierModal] = useState(false);
    const [openDropdownId, setOpenDropdownId] = useState(null);

    useEffect(() => {
        if (user_id) {
            document.title = "O'MEL Services | Chambres";
        }
    }, [user_id]);

    const [showModal, setShowModal] = useState(false);
    const [nouvelleChambre, setNouvelleChambre] = useState({
        nom: "",
        type: "",
    });

    const [chambreSelectionnee, setChambreSelectionnee] = useState({
        nom: '',
        type: '',
    });

    const handleSort = (key) => {
        let direction = "ascending";
        if (sortConfig.key === key && sortConfig.direction === "ascending") {
            direction = "descending";
        }
        setSortConfig({ key, direction });
    };

    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };

    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
    };

    const showAlertModal = (message, type = 'success') => {
        setAlertModal({ message, type });
    };

    const fermerNotif = () => {
        setAlert({ message: '', type: '' });
        setAlertModal({ message: '', type: '' });
    }

    // Récupération des essieux
    const fetchRooms = async () => {

        const token = localStorage.getItem('access_token');
        try {
            setIsLoading(true);
            const response = await fetch(process.env.REACT_APP_HOTE + "/listes-chambre/",
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                }
            );
            if (response.ok) {
                const data = await response.json();
                setChambres(data);
            }
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            console.error("Erreur lors de la récupération de la liste des chambres:", error);
        }
    };

    useEffect(() => {
        fetchRooms();
    }, []);

    // Filtrage 
    const chambreFiltrees = chambres.filter(chambre =>
        chambre?.nom?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        chambre?.type?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // Tri des données
    const chambreTriees = [...chambreFiltrees].sort((a, b) => {
        if (sortConfig.key) {
            const valueA = a[sortConfig.key]?.toString().toLowerCase() || "";
            const valueB = b[sortConfig.key]?.toString().toLowerCase() || "";
            if (valueA < valueB) return sortConfig.direction === "ascending" ? -1 : 1;
            if (valueA > valueB) return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
    });

    // Pagination
    const totalItems = chambreFiltrees.length;
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const chambreAffichees = chambreTriees.slice(indexOfFirstItem, indexOfLastItem);

    const handleSelectionChambre = (chambre) => {
        setChambreSelectionnee(chambre);
    };

    // Gestion du modal
    const handleOpenModal = () => setShowModal(true);
    const handleCloseModal = () => setShowModal(false);

    // Gestion du formulaire d'ajout
    const handleChange = (e) => {
        const { name, value } = e.target;
        setNouvelleChambre(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleAjouterEssieu = async () => {
        const erreurs = [];

        if (!nouvelleChambre.nom.trim()) {
            erreurs.push("Le nom est obligatoire.");
        }


        if (erreurs.length > 0) {
            showAlertModal(erreurs.join(" "), "danger");
            return;
        }

        const token = localStorage.getItem('access_token');
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/ajouter-chambre/`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(nouvelleChambre),
            });

            if (response.ok) {
                fetchRooms();
                setNouvelleChambre("");
                handleCloseModal();
                showAlert("Chambre ajoutée avec succès", "success");
                setTimeout(() => {
                    setAlert({ message: '', type: '' });
                }, 2000);
            } else {
                const errorData = await response.json();
                showAlertModal(errorData.error || "Erreur lors de l'ajout de la chambre", "danger");
            }
        } catch (error) {
            console.error("Erreur réseau:", error);
            showAlertModal("Une erreur est survenue. Veuillez réessayer.", "danger");
        }
    };

    const handleShowDeleteModal = (chambre) => {
        setChambreSelectionnee(chambre);
        setShowDeleteModal(true);
    };

    const handleCloseDeleteModal = () => {
        setShowDeleteModal(false);
    };

    const handleDeleteChambre = async () => {
        if (chambreSelectionnee) {

            const token = localStorage.getItem('access_token');
            try {
                const response = await fetch(process.env.REACT_APP_HOTE + `/supprimer-chambre/${chambreSelectionnee.id}/${user_id}/`,
                    {
                        method: 'DELETE',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                        },
                    }
                );

                if (response.ok) {
                    setChambres(chambres.filter((chambre) => chambre.id !== chambreSelectionnee.id));
                    setChambreSelectionnee(null);
                    setShowDeleteModal(false);
                    showAlert('Chambre supprimée avec succès !', "success");
                    setTimeout(() => {
                        setAlert({ message: '', type: '' });
                    }, 2000);
                } else {
                    console.error('Erreur lors de la suppression de la chambre');
                    showAlert('Erreur lors de la suppression', 'danger');
                }
            } catch (error) {
                console.error('Erreur réseau:', error);
                showAlert('Erreur réseau', 'danger');
            } finally {
                setShowDeleteModal(false);
            }
        }
    };

    const handleShowModifierModal = (chambre) => {
        setChambreSelectionnee(chambre);
        setShowModifierModal(true);
    };

    const handleCloseModifierModal = () => {
        setShowModifierModal(false);
    };

    const handleModifierChambre = async () => {
        if (chambreSelectionnee) {
            const erreurs = [];

            if (!chambreSelectionnee.nom.trim()) {
                erreurs.push("Le nom est obligatoire.");
            }

            if (erreurs.length > 0) {
                showAlertModal(erreurs.join(" "), "danger");
                return;
            }

            const token = localStorage.getItem('access_token');
            try {
                const response = await fetch(
                    `${process.env.REACT_APP_HOTE}/modifier-chambre/${chambreSelectionnee.id}/`,
                    {
                        method: 'PUT',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                        },
                        body: JSON.stringify({
                            nom: chambreSelectionnee.nom,
                            type: chambreSelectionnee.type,
                        }),
                    }
                );

                if (response.ok) {
                    fetchRooms();
                    setShowModifierModal(false);
                    showAlert('Chambre modifiée avec succès !');
                    setTimeout(() => {
                        setAlert({ message: '', type: '' });
                    }, 2000);
                } else {
                    console.error('Erreur lors de la modification de la chambre', "success");
                    showAlert('Erreur lors de la modification', 'danger');
                }
            } catch (error) {
                console.error('Erreur réseau:', error);
                showAlert('Erreur réseau', 'danger');
            } finally {
                setShowModifierModal(false);
            }
        }
    };


    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2></h2>
                            <h2 className="d-flex justify-content-between align-items-center">
                                <div className="d-flex align-items-center">
                                    <FaBed size={25} className='mr-2' />Chambres
                                </div>

                            </h2>
                            <small>Administration des chambres.</small>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    {/* <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/`}> Accueil</Link>
                                    </li> */}
                                    <li className="breadcrumb-item custom-breadcrumb-item active">
                                        Chambres
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    {alert.message && (
                        <div className={`m-3 alert alert-${alert.type} row justify-content-between position-relative`}>
                            <div dangerouslySetInnerHTML={{ __html: alert.message }} />
                            <span
                                onClick={fermerNotif}
                                style={{
                                    position: 'absolute',
                                    top: '0px',
                                    right: '10px',
                                    cursor: 'pointer'
                                }}
                            >
                                <i className='fa fa-close'></i>
                            </span>
                        </div>
                    )}
                    <div className="wrapper wrapper-content animated fadeInRight mt-3">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h5>Liste des chambres </h5>
                            <div className="d-flex mt-md-0" style={{ gap: '10px' }}>
                                <button className="btn btn-success mr-2 d-flex align-items-center justify-content-center" onClick={handleOpenModal}>
                                    <FaPlus />
                                    <span className="d-none d-sm-inline ml-2">Ajouter</span>
                                </button>

                            </div>
                        </div>

                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content">
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <div className="me-2">
                                                <select
                                                    value={itemsPerPage}
                                                    onChange={handleItemsPerPageChange}
                                                    className="form-select bg-default p-1"
                                                    style={{
                                                        width: "auto",
                                                        border: "1px black solid",
                                                        borderRadius: "5px",
                                                    }}
                                                >
                                                    <option value={10}>10</option>
                                                    <option value={20}>20</option>
                                                    <option value={50}>50</option>
                                                </select>
                                            </div>
                                            <div className="row justify-content-center align-items-center">
                                                <input
                                                    type="text"
                                                    placeholder="Rechercher..."
                                                    className="form-control mr-2"
                                                    style={{ maxWidth: "150px", width: "100%" }}
                                                    value={searchTerm}
                                                    onChange={(e) => setSearchTerm(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="table-responsive">
                                            <table className="footable table table-stripped footable-loaded tablet breakpoint">
                                                <thead>
                                                    <tr>
                                                        <th className="text-secondary text-wrap d-none d-md-table-cell text-justify" onClick={() => handleSort("reference")}>
                                                            Référence
                                                            {sortConfig.key === "reference"}{sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                        </th>
                                                        <th className="text-secondary text-wrap d-none d-md-table-cell text-center" onClick={() => handleSort("nom")}>
                                                            Nom
                                                            {sortConfig.key === "nom"}{sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                        </th>
                                                        <th className="text-secondary text-wrap d-none d-md-table-cell text-center" onClick={() => handleSort("type")}>
                                                            type
                                                            {sortConfig.key === "type"}{sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                        </th>
                                                        {/* <th className="text-secondary text-wrap d-none d-md-table-cell text-center" onClick={() => handleSort("statut")}>
                                                            Statut
                                                            {sortConfig.key === "statut"}{sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                        </th> */}
                                                        <th className="text-center">Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {isLoading ? (
                                                        <tr>
                                                            <td colSpan="2" className="text-center">Chargement...</td>
                                                        </tr>
                                                    ) : chambreAffichees.length > 0 ? (
                                                        chambreAffichees.map((essieu) => (
                                                            <tr key={essieu.id}>
                                                                <td className="d-none d-md-table-cell text-justify">{essieu.reference}</td>
                                                                <td className="d-none d-md-table-cell text-center">{essieu.nom}</td>
                                                                <td className="d-none d-md-table-cell text-center">{essieu.type}</td>
                                                                {/* <td className="d-none d-md-table-cell text-center">{essieu.statut}</td> */}
                                                                <td className="text-center" style={{ position: 'relative' }}>
                                                                    <div>
                                                                        <button
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                setOpenDropdownId(openDropdownId === essieu.id ? null : essieu.id);
                                                                            }}
                                                                            style={{
                                                                                background: 'none',
                                                                                border: 'none',
                                                                                padding: '0 5px',
                                                                                cursor: 'pointer'
                                                                            }}
                                                                        >
                                                                            <FaEllipsisV title="Actions" />
                                                                        </button>

                                                                        {openDropdownId === essieu.id && (
                                                                            <div
                                                                                style={{
                                                                                    position: 'fixed',
                                                                                    zIndex: 1000,
                                                                                    minWidth: '150px',
                                                                                    right: '100px',
                                                                                    backgroundColor: 'white',
                                                                                    border: '1px solid #ddd',
                                                                                    borderRadius: '4px',
                                                                                    boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
                                                                                    maxHeight: '150px',
                                                                                    overflowY: 'auto',
                                                                                    scrollbarWidth: 'thin',
                                                                                    scrollbarColor: '#ddd #f8f9fa',
                                                                                }}
                                                                                className="custom-scrollbar"
                                                                            >
                                                                                <div
                                                                                    style={{
                                                                                        padding: '8px 16px',
                                                                                        display: 'flex',
                                                                                        alignItems: 'center',
                                                                                        cursor: 'pointer',
                                                                                        ':hover': {
                                                                                            backgroundColor: '#f8f9fa'
                                                                                        }
                                                                                    }}
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        handleShowModifierModal(essieu);
                                                                                        setOpenDropdownId(null);
                                                                                    }}
                                                                                >
                                                                                    <FaEdit className="mr-2" style={{ color: "blue" }} size={14} />
                                                                                    <span>Modifier</span>
                                                                                </div>

                                                                                <div style={{ borderTop: '1px solid #eee' }} />

                                                                                <div
                                                                                    style={{
                                                                                        padding: '8px 16px',
                                                                                        display: 'flex',
                                                                                        alignItems: 'center',
                                                                                        cursor: 'pointer',
                                                                                        ':hover': {
                                                                                            backgroundColor: '#f8f9fa'
                                                                                        }
                                                                                    }}
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        handleShowDeleteModal(essieu);
                                                                                        setOpenDropdownId(null);
                                                                                    }}
                                                                                >
                                                                                    <FaTrash className="mr-2" style={{ color: "red" }} size={14} />
                                                                                    <span>Supprimer</span>
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="9" className="text-center">Aucune chambre trouvée.</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>

                                        {/* Pagination */}
                                        <div className="d-flex justify-content-between align-items-center mt-3">
                                            <div>
                                                {chambreFiltrees.length === 0
                                                    ? "Aucun élément à afficher"
                                                    : `Affichage de ${indexOfFirstItem + 1} à ${Math.min(indexOfLastItem, chambreFiltrees.length)} sur ${chambreFiltrees.length}`}
                                            </div>
                                            <div className="d-flex align-items-center">
                                                <button
                                                    onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                                                    className={`btn ${currentPage === 1 ? "btn-outline-secondary" : "btn-outline-primary"} mx-1`}
                                                    disabled={currentPage === 1}
                                                >
                                                    <FaArrowLeft />
                                                </button>

                                                {(() => {
                                                    const pagesToShow = 5;
                                                    let startPage = Math.max(
                                                        1,
                                                        currentPage - Math.floor(pagesToShow / 2)
                                                    );
                                                    let endPage = Math.min(
                                                        totalPages,
                                                        startPage + pagesToShow - 1
                                                    );

                                                    if (endPage - startPage < pagesToShow - 1) {
                                                        startPage = Math.max(
                                                            1,
                                                            endPage - pagesToShow + 1
                                                        );
                                                    }

                                                    const pageButtons = [];

                                                    for (let i = startPage; i <= endPage; i++) {
                                                        pageButtons.push(
                                                            <button
                                                                key={i}
                                                                onClick={() => setCurrentPage(i)}
                                                                className={`btn ${currentPage === i
                                                                    ? "btn-default"
                                                                    : "btn-light"
                                                                    } mx-1`}
                                                            >
                                                                {i}
                                                            </button>
                                                        );
                                                    }

                                                    return pageButtons;
                                                })()}
                                                <button
                                                    onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                                                    className={`btn ${currentPage === totalPages ? "btn-outline-secondary" : "btn-outline-primary"} mx-1`}
                                                    disabled={currentPage === totalPages}
                                                >
                                                    <FaArrowRight />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal d'enregistrement */}
            <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header>
                    <Modal.Title>Ajouter une chambre</Modal.Title>
                </Modal.Header>
                {alertModal.message && (
                    <div className={`m-2 alert alert-${alertModal.type} row justify-content-between position-relative`}>
                        <div dangerouslySetInnerHTML={{ __html: alertModal.message }} />
                        <span onClick={fermerNotif} style={{ cursor: 'pointer' }}>
                            <i className='fa fa-close'></i>
                        </span>
                    </div>
                )}
                <Modal.Body>
                    <Form>
                        <Form.Group controlId="formEssieu">
                            <Form.Label className="">Nom <span style={{ color: 'red' }}>*</span></Form.Label>
                            <Form.Control
                                type="text"
                                name="nom"
                                value={nouvelleChambre?.nom || ''}
                                onChange={handleChange}
                            // placeholder="nom"
                            />

                            <Form.Label className="mt-2">Type</Form.Label>
                            <Form.Control
                                type="text"
                                name="type"
                                value={nouvelleChambre?.type || ''}
                                onChange={handleChange}
                            // placeholder="Description du type d'essieu (facultatif)"
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>
                        <strong>Fermer</strong>
                    </Button>
                    <Button variant="success" onClick={handleAjouterEssieu}>
                        <strong>Ajouter</strong>
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modal de confirmation de suppression */}
            <Modal show={showDeleteModal} onHide={handleCloseDeleteModal}>
                <Modal.Header>
                    <Modal.Title>Confirmer la Suppression</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Êtes-vous sûr de vouloir supprimer la chambre<strong>{chambreSelectionnee?.nom}</strong> ?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseDeleteModal}>
                        <strong>Fermer</strong>
                    </Button>
                    <Button variant="success" onClick={handleDeleteChambre}>
                        <strong>Supprimer</strong>
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modal de modification */}
            <Modal show={showModifierModal} onHide={handleCloseModifierModal}>
                <Modal.Header>
                    <Modal.Title>Modifier la chambre</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group controlId="formEssieu">
                            <Form.Label className="">Nom <span style={{ color: 'red' }}>*</span></Form.Label>
                            <Form.Control
                                type="text"
                                name="nom"
                                value={chambreSelectionnee?.nom || ''}
                                onChange={(e) =>
                                    setChambreSelectionnee({ ...chambreSelectionnee, nom: e.target.value })
                                }
                            />

                            <Form.Label className="mt-2">Type</Form.Label>
                            <Form.Control
                                type="text"
                                name="type"
                                value={chambreSelectionnee?.type || ''}
                                onChange={(e) =>
                                    setChambreSelectionnee({ ...chambreSelectionnee, type: e.target.value })
                                }
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModifierModal}>
                        <strong>Fermer</strong>
                    </Button>
                    <Button variant="success" onClick={handleModifierChambre}>
                        <strong>Modifier</strong>
                    </Button>
                </Modal.Footer>
            </Modal>


        </div>
    );
};

export default Chambre;